import React, { FunctionComponent } from 'react';
import QuestionFormSection from '@/components/GreenCards/QuestionFormSection/QuestionFormSection';
import TypesOfGreenCard from '@/components/GreenCards/TypesOfGreenCard/TypesOfGreenCard';
import { Layout } from '@/components/Layout';
import TestimonialsCTA from '@/components/Testimonials/TestimonialsCTA';
import TestimonialsSectionContainer from '@/components/Testimonials/TestimonialsSectionContainer';
import { handleFormSubmit } from '@/utils/handleFormSubmit';
import { Col, Hero } from '@visalex/core';

import cx from 'clsx';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import styles from '@/components/GreenCards/GreenPage.module.scss';

const prefix = 'green-cards';

const GreenCardsPage: FunctionComponent = () => {
  const { t } = useTranslation();

  const { handleSubmit, isSubmitWithError } = handleFormSubmit();

  return (
    <Layout title={t(`${prefix}.seo-title`)} description={t(`${prefix}.seo-description`)}>
      <div className={cx(styles[`${prefix}`])}>
        <Hero className={styles[`${prefix}__hero`]}>
          <Col xs={12} className="mx-auto">
            <img src="/images/visa-pages/green-cards-cover.png" alt={t(`${prefix}.hero.imageAlt.green-cards-cover`)} />
            <h1 style={{ marginTop: 40 }}>{t(`${prefix}.hero.title`)}</h1>
            <p>{t(`${prefix}.hero.subtitle`)}</p>
          </Col>
        </Hero>
        <TypesOfGreenCard />
        <TestimonialsSectionContainer className={cx(styles[`${prefix}__testimonials-background`])}>
          <TestimonialsCTA withImg />
        </TestimonialsSectionContainer>

        <QuestionFormSection handleSubmit={handleSubmit} isSubmitWithError={isSubmitWithError} />
      </div>
    </Layout>
  );
};

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
}

export default GreenCardsPage;
